<div *ngIf="sale">
  <mat-card appearance="outlined" class="sale-card col-12 col-md-8 offset-md-2">
    <mat-card-title-group>
      <mat-card-title>Prix: {{sale.price | currency: 'EUR':'symbol':'1.0'}}</mat-card-title>
      <mat-card-subtitle>Statut: {{'enum.SellingStatus.' + sale.status | translate}}</mat-card-subtitle>
      <button *ngIf="canManageSale" mat-icon-button color="primary" [matMenuTriggerFor]="actions">
        <mat-icon>more_vert</mat-icon>
      </button>
    </mat-card-title-group>
    <mat-card-content class="text-center">
      <div *ngIf="realtorUniqueName; else multipleRealtors"><span class="player">Agent :</span><span>{{
          realtorUniqueName }}</span></div>
      <div *ngIf="notaryUniqueName; else multipleNotaries"><span class="player">Notaire :</span><span>{{
          notaryUniqueName }}</span>
      </div>
      <div *ngIf="buyerName"><span class="player">Acquéreur :</span><span>{{ buyerName }}</span></div>
      <div *ngIf="coBuyerName"><span class="player">Co-acquéreur :</span><span>{{ coBuyerName }}</span></div>
    </mat-card-content>
  </mat-card>

  <ng-container *ngIf="events.length>0">
    <app-timeline [events]="events"></app-timeline>
  </ng-container>

  <ng-template #multipleRealtors>
    <div *ngIf="realtorSellerName"><span class="player">Agent vendeur:</span><span>{{ realtorSellerName }}</span></div>
    <div *ngIf="realtorSellerName"><span class="player">Agent acquéreur:</span><span>{{ realtorBuyerName }}</span></div>
  </ng-template>
  <ng-template #multipleNotaries>
    <div *ngIf="notarySellerName"><span class="player">Notaire vendeur:</span><span>{{ notarySellerName }}</span></div>
    <div *ngIf="notarySellerName"><span class="player">Notaire acquéreur:</span><span>{{ notaryBuyerName }}</span></div>
  </ng-template>
</div>

<mat-menu #actions="matMenu">
  <ng-template matMenuContent>
    <ul class="menu-actions">
      <li>
        <a (click)="editSaleDates()"><mat-icon color="primary">create</mat-icon><span class="text">Modifier la
            vente</span></a>
      </li>
      <li>
        <a (click)="editSaleStatus()"><mat-icon color="primary">check_circle_outline</mat-icon><span class="text">Mettre
            à jour le
            statut</span></a>
      </li>
      <li>
        <a (click)="sendGenerateEPub()"><mat-icon color="primary">campaign</mat-icon><span class="text">Générer une
            E-Pub</span></a>
      </li>
      <ng-container *ngIf="this.prop.certified">
        <li>
          <a (click)="editSalePlayers()"><mat-icon color="primary">people</mat-icon><span class="text">Gérer les
              intervenants</span></a>
        </li>
        <li *ngIf="!this.sale.buyer">
          <a (click)="addSaleBuyers()"><mat-icon color="primary">group_add</mat-icon><span class="text">Définir les
              acquéreurs</span></a>
        </li>
        <li *ngIf="this.sale.buyer">
          <a (click)="confirmDeleteBuyers()"><mat-icon color="primary">group_remove</mat-icon><span
              class="text">Supprimer
              les acquéreurs</span></a>
        </li>
      </ng-container>
    </ul>
  </ng-template>
</mat-menu>